import React, { useState ,useEffect,useRef} from 'react';
import { TextField, Button, Card, CardContent ,Typography,Box,IconButton, InputAdornment} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link ,useNavigate} from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import api from '../Services/api';

export const OtpBoxes = ({ otp, setOtp }) => {
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    const otpArray = otp.split('');
    otpArray[index] = value;
    setOtp(otpArray.join(''));

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  return (
    <Box display="flex" gap={1} justifyContent="center" mt={2}>
      {Array.from({ length: 6 }).map((_, i) => (
        <TextField
          key={i}
          inputRef={(el) => (inputsRef.current[i] = el)}
          value={otp[i] || ''}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          inputProps={{
            maxLength: 1,
            style: {
              width: '20px',
              textAlign: 'center',
              fontSize: '12px',
              padding: '8px',
            },
          }}
          variant="outlined"
        />
      ))}
    </Box>
  );
};



const Forgot = ({userType}) => {


  
   const navigate=useNavigate();
   const [userName, setUserName] = useState('');

  const [otp, setOtp] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [step, setStep] = useState(1); 
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [seconds, setSeconds] = useState(120);
  const [newPassword, setNewPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');

  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const handleToggleVisibilityConfirm = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;

const validatePassword = (password) => {
  return passwordRegex.test(password);
};



  useEffect(() => {
    if (typeof seconds === "number" && seconds > 0) {
      const timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else if (seconds === 0) {
      setSeconds("OTP Expired!");
    }
  }, [seconds]);
  

  
  const convertHMS = (value) => {
    const sec = parseInt(value, 10);
    let minutes = Math.floor(sec / 60);
    let seconds = sec % 60;
  
    if (minutes < 10) minutes = "0" + minutes;
    if (seconds < 10) seconds = "0" + seconds;
  
    return `${minutes}:${seconds}`;
  };
  
  const handleResendOtp = async (userType,userName) => {
   setOtp('')
    setSeconds(120);
    try{
      const payload = {
        type: userType,
        username: userName,
      };
    const response = await api.forgotPassword.forgotPasswsord(payload)
    if(response.status === 200){
      setSnackbarOpen(true);
      setSnackbarMessage(response.data.message)
  setStep(2);
    }
    else if (response.status === 404) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage(response.data.message)
  
      
  }
  else if (response.status === 400) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)
  
    
  }
  else if (response.status === 500) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)
  
    
  }
    } 
    catch (error) {
      console.error("Vendor could not be fetched:", error);
  }
   
  }

  const handleSendOtp = async (userType,userName) => {
    setSeconds(120);
  try{
    const payload = {
      type: userType,
      username: userName,
    };
  const response = await api.forgotPassword.forgotPasswsord(payload)
  if(response.status === 200){
    setSnackbarOpen(true);
    setSnackbarMessage(response.data.message)
setStep(2);
  }
  else if (response.status === 404) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)

    
}
else if (response.status === 400) {
  setErrorSnackbarOpen(true);
  setSnackbarErrorMessage(response.data.message)

  
}
else if (response.status === 500) {
  setErrorSnackbarOpen(true);
  setSnackbarErrorMessage(response.data.message)

  
}
  } 
  catch (error) {
    console.error("Vendor could not be fetched:", error);
}


  
    
  };

  const handleVerifyOtp = async (userType,userName,otp) => {
    try{
      const payload = {
        type: userType,
        username: userName,
        verificationCode: otp
      };
    const response = await api.forgotPassword.verifyOTP(payload)
    if(response.status === 200){
      setSnackbarOpen(true);
      setSnackbarMessage(response.data.message)
      setStep(3);
    }
    else if (response.status === 404) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage(response.data.message)
      setOtp('')
  
      
  }
  else if (response.status === 400) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)
    setOtp('')
  
    
  }
  else if (response.status === 500) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)
    setOtp('')
  
    
  }
    } 
    catch (error) {
      console.error("Vendor could not be fetched:", error);
  }
    
  };

  const handleResetPassword = async(userType,userName,newPassword,confirmPassword) => {
    try{
      const payload = {
        type: userType,
        username: userName,
        verificationCode: otp,
        newPassword : newPassword,
        confirmPassword : confirmPassword

      };
    const response = await api.forgotPassword.resetPassword(payload)
    if(response.status === 200){
      setSnackbarOpen(true);
      setSnackbarMessage(response.data.message)
     setNewPassword('')
    setConfirmPassword('')
    const redirectTimer = setTimeout(() => {
        navigate('/signin'); 
    },3000)
   return () => {
        clearTimeout(redirectTimer);
      };
    }
    
    else if (response.status === 404) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage(response.data.message)
  
      
  }
  else if (response.status === 429) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage(response.data.message)
   

    
}
  else if (response.status === 400) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)
  
    
  }
  else if (response.status === 500) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(response.data.message)
  
    
  }
    } 
    catch (error) {
      console.error("Vendor could not be fetched:", error);
  }
  };


  return (
    <section>
      <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                
                }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
              
              >
                <SnackbarContent style={{ backgroundColor: "green",fontWeight: 'bold',
      transform: 'translate(80px, -120px)' }} message={snackbarMessage} />
              </Snackbar>
              <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                severity="error"
                open={errorSnackbarOpen}
                autoHideDuration={2000}
              
                onClose={() => {setErrorSnackbarOpen(false)}}
              >
                <SnackbarContent style={{ backgroundColor: "red" , color: 'white',
      fontWeight: 'bold',
      transform: 'translate(80px, -120px)'}} message={snackbarErrorMessage} />
              </Snackbar>
 
      <div>
   
        {step === 1 && (
          
          <div className="d-grid" >

            <TextField 
            className="mt-4"
              label="Enter Username"
              variant="outlined"
              value={userName}
              
              onChange={(e) => setUserName(e.target.value)}
            />
            <button className="d-flex justify-content-end text-danger mb-4 mt-2" style={{fontSize:'13px'}} onClick={() =>   navigate('/signin')}>Back to login</button>

            <button className="btn btn-danger " disabled={!userName} onClick={() => handleSendOtp(userType,userName)}>Send OTP</button>
          </div>
        )}
        {step === 2 && (
          <div className='d-grid'>
             <Typography className="text-center pt-4" style={{fontSize:'15px'}} variant='secondary' >Check your registered mail for OTP</Typography>
             <OtpBoxes otp={otp} setOtp={setOtp} />

            <button className="d-flex justify-content-end text-danger mb-2 mt-4" style={{fontSize:'13px'}} onClick={() =>   navigate('/signin')}> Back to login</button>

            <button className="btn btn-danger mb-1" onClick={()=> handleVerifyOtp(userType,userName,otp)}>Verify OTP</button>
            <Box >
              {seconds == "OTP Expired!" ?(
              <Typography color="text"  variant="body2" align="center" >
              OTP Expired?{" "} <Typography
                      sx={{ cursor: "pointer" }}
                      variant="button"
                      color="error"
                      
                      justifyContent="center"
                      textGradient
                      onClick={() => handleResendOtp(userType,userName)}
                    >
                      Resend OTP
                    </Typography>
            </Typography>
                ):(
                  <Typography align="center" color="text" variant="body2">
                  OTP Expires in   <Typography  color="error">
  {typeof seconds === "number" ? convertHMS(seconds) : seconds}
  </Typography>
                </Typography>
                )}
             
            </Box>
          </div>
        )}
        {step === 3 && (
          <div className="d-grid">
             {/* <Typography className="text-center pt-2" variant='secondary' >Reset Password</Typography> */}
            <TextField
             className="mt-4 mb-3"
             type={showPassword ? 'text' : 'password'}
              label="New Password"
              variant="outlined"
              value={newPassword}
              onChange={(e) => {
                const value = e.target.value;
                setNewPassword(value);
            
                if (!validatePassword(value)) {
                  setPasswordError('Password must be 8–12 characters long, include uppercase, lowercase, number, special character, and no spaces');
                } else {
                  setPasswordError('');
                }
              }}
              error={Boolean(passwordError)}
              helperText={passwordError}
              fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleToggleVisibility} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
            
            <TextField
        
        type={showConfirmPassword ? 'text' : 'password'}
              label="Confirm Password"
              variant="outlined"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleToggleVisibilityConfirm} edge="end">
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <button className="d-flex justify-content-end text-danger mb-3 mt-2" style={{fontSize:'13px'}} onClick={() =>   navigate('/signin')}>Back to login</button>

            <button className="btn btn-danger" onClick={()=>handleResetPassword(userType,userName,newPassword,confirmPassword)}   disabled={Boolean(passwordError) || newPassword === ''}>Reset Password</button>
          </div>
        )}
    
          
      </div>
   
    </section>
   
  );
};

export default Forgot;
